/**
 * Created by bozin on 19.02.18.
 */

import en from './pack/en.json'
import ru from './pack/ru.json'

export default {
  default: 'ru',
  en: en,
  ru: ru
}
